export default __webpack_public_path__ + "fa4da574dc55d784b5b7eb91d2a160ba.jpg";